export default "__VITE_ASSET__DNsu5JYm__"